import { render, staticRenderFns } from "./schoolCalendar.vue?vue&type=template&id=4dd505e5&scoped=true"
import script from "./schoolCalendar.vue?vue&type=script&lang=js"
export * from "./schoolCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd505e5",
  null
  
)

export default component.exports